var map = {
	"./view_atoms/system_actions/restart_system_button/component_controller.js": 510,
	"./view_molecules/archived_mails/archived_mail/component_controller.js": 511,
	"./view_molecules/points_tables/all_periods_points_tables/component_controller.js": 512,
	"./view_molecules/points_tables/structure_points_table/component_controller.js": 513,
	"./view_molecules/recommendations_tables/load_more_recommendations_button/component_controller.js": 514,
	"./view_molecules/recommendations_tables/recommendations_column_component/component_controller.js": 515
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 509;